const getSearch = state => state.search || {};

const getSearchValue = state => getSearch(state).searchValue;
const getSearchResults = state => getSearch(state).searchResults;
const getHelpSearchResults = state => getSearch(state).helpSearchResults;

const getAutoSuggestions = state => getSearchResults(state).suggestions || [];
const getAutoSuggestionsCount = state => getAutoSuggestions(state).length;

const getCategories = state => getSearchResults(state).categories || [];
const getCategoriesCount = state => getCategories(state).length;

const getProducts = state => getSearchResults(state).products || [];
const getProductsCount = state => getProducts(state).length;

const getBaseUrlSuffix = state => getSearchResults(state).baseUrlSuffix || '';

const getProductsTotalNumberOfResults = state =>
    getSearchResults(state).productsTotalNumberOfResults;

const getContentSuggestions = state => getSearchResults(state).content || [];
const getContentSuggestionsCount = state => getContentSuggestions(state).length;

const getStores = state => getSearchResults(state).stores || [];

const getRecentSearches = state => getHelpSearchResults(state).recent || [];
const getRecentSearchesCount = state => getRecentSearches(state).length;

const getNoResultsMessage = state => getSearchResults(state).noResultsMessage || '';
const hasNoResults = state => !getSearchResults(state).hasResults;

const getBrands = state => getSearchResults(state).brands || [];
const getBrandsCount = state => getBrands(state).length;
const getHasExternalCatalogsMapping = state =>
    getSearchResults(state).hasExternalCatalogsMapping || false;

const getPopularSuggestions = state => getHelpSearchResults(state).popular || [];
const getPopularSuggestionsCount = state => getPopularSuggestions(state).length;

const getSuggestionsReceivedStatus = state => getSearch(state).suggestionsReceived;
const allSearchResults = state => getSearchResults(state).static || {};
const getAPIResponseSucceded = state => getSearch(state).APIResponse;
const isFilterLoading = state => getSearch(state).filterLoading;
const getPLPResults = state => getSearch(state).plp || {};
const getNewDoc = state => getPLPResults(state).newDoc;
const getNewUri = state => getPLPResults(state).newUri;
const areFiltersApplied = state => !getSearch(state).filtersAreNotApplied;
const isFilterExpanded = (state, filterGroupUid) =>
    !!getSearch(state).expandedFilters[filterGroupUid];
const getLastChangedFiltersGroup = state => getSearch(state).lastChangedFiltersGroup;

const getSecondaryResultsTotal = state => getSearch(state).secondaryResultsTotal;
const areSuggestionsOpened = state => getSearch(state).suggestionsOpened;
const getLastSearch = state => getSearch(state).lastSearch;
const getSearchFromCategories = state => getSearch(state).searchFromCategories;
const isFilterAccordionOpened = (state, filterAccordionName) =>
    getSearch(state).expandedFilterAccordions[filterAccordionName];
const isFacetGroupSelected = (state, id) => getSearch(state).selectedFacetGroups[id];
const getFilterPriceRange = state => getSearch(state).selectedFilterPriceRange;
const getSearchForExtService = (state, eventType) =>
    getSearch(state).searchForExtService[eventType] || {};
const getExternalCatalogsMapping = state => getSearchResults(state).externalCatalogsMapping || {};
const getRemoveSeoText = state => getSearch(state).removeSeoText || false;


export default {
    getSearchValue,
    getSearchResults,
    getCategories,
    getCategoriesCount,
    getProducts,
    getProductsCount,
    getContentSuggestions,
    getContentSuggestionsCount,
    getAutoSuggestions,
    getAutoSuggestionsCount,
    getStores,
    getRecentSearches,
    getRecentSearchesCount,
    getNoResultsMessage,
    hasNoResults,
    allSearchResults,
    getAPIResponseSucceded,
    isFilterLoading,
    getPLPResults,
    getNewDoc,
    getNewUri,
    areFiltersApplied,
    isFilterExpanded,
    getLastChangedFiltersGroup,
    getSecondaryResultsTotal,
    getProductsTotalNumberOfResults,
    getSuggestionsReceivedStatus,
    getBrands,
    getBrandsCount,
    getPopularSuggestions,
    getPopularSuggestionsCount,
    areSuggestionsOpened,
    getLastSearch,
    getSearchFromCategories,
    isFilterAccordionOpened,
    isFacetGroupSelected,
    getFilterPriceRange,
    getSearchForExtService,
    getBaseUrlSuffix,
    getExternalCatalogsMapping,
    getRemoveSeoText,
    getHasExternalCatalogsMapping,
};
